import { render, staticRenderFns } from "./WtBreadcrumb.vue?vue&type=template&id=2c2f82ff&scoped=true"
import script from "./WtBreadcrumb.vue?vue&type=script&lang=js"
export * from "./WtBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./WtBreadcrumb.vue?vue&type=style&index=0&id=2c2f82ff&prod&lang=scss&scoped=true"
import style1 from "./WtBreadcrumb.vue?vue&type=style&index=1&id=2c2f82ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2f82ff",
  null
  
)

export default component.exports